import BufferOp from 'jsts/org/locationtech/jts/operation/buffer/BufferOp';
import OverlayOp from 'jsts/org/locationtech/jts/operation/overlay/OverlayOp';
import IsValidOp from 'jsts/org/locationtech/jts/operation/valid/IsValidOp';
import { reader, writer } from './io';

/**
 * Calculates the intersection of two features.
 * @param {Object} featureA - A GeoJSON Feature object.
 * @param {Object} featureB - A GeoJSON Feature object.
 * @returns {Object} A GeoJSON Feature object representing the intersection of the input features.
 */
export default function intersection(featureA, featureB) {
  // Function to clean a geometry by buffering it by 0
  const cleanGeom = (g) => BufferOp.bufferOp(g, 0);

  const featureToIntersect = [featureA, featureB].map((feature) => {
    let geom = reader.read(feature).geometry;
    // If the geometry is not valid, clean it
    if (!IsValidOp.isValid(geom)) {
      geom = cleanGeom(geom);
    }
    return geom;
  });

  const intersectionGeom = OverlayOp.intersection(...featureToIntersect);

  // Clean intersection
  const cleanedIntersectionGeom = cleanGeom(intersectionGeom);

  // Return intersection feature
  return {
    type: 'Feature',
    geometry: writer.write(cleanedIntersectionGeom),
    properties: {
      area: intersectionGeom.getArea(),
    },
  };
}
